import { render, staticRenderFns } from "./Roads.vue?vue&type=template&id=17667103&scoped=true"
import script from "./Roads.vue?vue&type=script&lang=js"
export * from "./Roads.vue?vue&type=script&lang=js"
import style0 from "./Roads.vue?vue&type=style&index=0&id=17667103&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17667103",
  null
  
)

export default component.exports